import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
@Component({
  selector: 'app-about-us',
  templateUrl: './about-us.component.html',
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./about-us.component.scss']
})
export class AboutComponent implements OnInit {
  header:string ='Who We Are';
  description:string ='We are a cybersecurity company based in Riyadh specialized in building modern platforms to solve  cybersecurity and enterprise GRC challenges';
  joinChat:boolean=true;
  imagePath ="../../../../assets/images/undraw_mobile_search_jxq5 1.png";

  imageText="Learn about the services we offer through our experienced team in various cybersecurity fields";
  imageUrl="/assets/images/about-us-small-banner.jpg"
  buttonText="Learn more";
  routerButton="/services";
  isProductsPage: boolean = false



  constructor(iconRegistry: MatIconRegistry, sanitizer: DomSanitizer) {
    iconRegistry.addSvgIcon(
      "thumb",
      sanitizer.bypassSecurityTrustResourceUrl("../assets/svg/thumb_icon.svg")
    );
    iconRegistry.addSvgIcon(
      "chart",
      sanitizer.bypassSecurityTrustResourceUrl("../assets/svg/chart.svg")
    );
    iconRegistry.addSvgIcon(
      "tree",
      sanitizer.bypassSecurityTrustResourceUrl("../assets/svg/tree.svg")
    );

  }


  ngOnInit(): void {
  }

}
